import { Logo } from "@/components/SiteHeader";
import { TripSummary } from "./TripSummary";
import { TisScore } from "./TisScore";
import { Neighborhoods } from "./Neighborhoods";
import { Itinerary } from "./Itinerary";
import { Improvements, BudgetSplit } from "./Improvements";
import { BookingBoxes } from "./BookingBoxes";
import { TripActions } from "./TripActions";
import { OnlineBox, PrintPageFooter } from "./OnlineCta";
import { T, useLang } from "@/i18n";
import { useState } from "react";
import { TranslateBar } from "./TranslateBar";
import { EmailItinerary } from "./EmailItinerary";
import { EmailPopup } from "./EmailPopup";

export const TripResult = ({ trip }) => {
  const { lang } = useLang();
  const [translations, setTranslations] = useState(trip.translations || {});
  const [showOriginal, setShowOriginal] = useState(false);
  const p = (!showOriginal && translations[lang]) || trip.plan || {};
  const url = `${window.location.origin}/viaggio/${trip.id}`;
  return (
    <div data-testid="ai-output-section" className="rise mt-14 pdf-locked">
      <div className="print-locked-note">
        <Logo />
        <p className="mt-8 text-2xl font-semibold"><T>Ricevi il preventivo gratuito via email</T></p>
        <p className="mt-3"><T>Il PDF completo è gratuito: richiedilo inserendo la tua email nella pagina del viaggio:</T></p>
        <p className="mt-2 break-all font-semibold text-emerald-700">{url}</p>
      </div>
      <table className="print-wrap w-full">
        <tbody><tr><td>
          <div className="space-y-6">
            <div className="print-only mb-6">
              <Logo />
              <p className="mt-2 text-sm text-gray-500"><T>Ogni viaggio può fare la differenza. · tripsaver.it</T></p>
            </div>
            <TranslateBar trip={trip} translations={translations} setTranslations={setTranslations} showOriginal={showOriginal} setShowOriginal={setShowOriginal} />
            <TripSummary summary={p.summary} />
            <OnlineBox url={url} />
            <TisScore tis={p.tis} />
            <Itinerary days={p.itinerary} />
            <Neighborhoods neighborhoods={p.neighborhoods} avoid={p.avoid_areas} gems={p.local_gems} />
            <EmailItinerary tripId={trip.id} />
            <EmailPopup key={trip.id} tripId={trip.id} />
            <Improvements items={p.improvements} score={p.tis?.score ?? 0} />
            <BudgetSplit items={p.budget_split} />
            <BookingBoxes flights={p.flights} hotels={p.hotels} destination={p.summary?.destination} route={trip.plan?.flights} tripId={trip.id} />
            <OnlineBox url={url} />
            <TripActions trip={trip} />
          </div>
        </td></tr></tbody>
        <tfoot className="print-footer-space"><tr><td><div style={{ height: "22mm" }} /></td></tr></tfoot>
      </table>
      <PrintPageFooter url={url} />
    </div>
  );
};
